const api = require("./api");
const auth = require("./auth");
const memo = require("./auth/memo");
const broadcast = require("./broadcast");
const config = require("./config");
const formatter = require("./formatter")(api);
const utils = require("./utils");

const blurt = {
  api,
  auth,
  memo,
  broadcast,
  config,
  formatter,
  utils,
};

if (typeof window !== "undefined") {
  window.blurt = blurt;
}

if (typeof global !== "undefined") {
  global.blurt = blurt;
}

exports = module.exports = blurt;



// WEBPACK FOOTER //
// ./src/browser.js